import * as React from 'react';
import {loadModules} from 'esri-loader';

export default class SimpleMarker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            graphic: null
        };
    }

    render() {
        return null;
    }

    componentDidMount() {
        loadModules(['esri/Graphic', 'esri/geometry/Circle', 'esri/symbols/SimpleLineSymbol', 'esri/symbols/SimpleFillSymbol', 'esri/Color', 'esri/geometry/SpatialReference',])
            .then(([Graphic, Circle, SimpleLineSymbol, SimpleFillSymbol, Color, SpatialReference]) => {
                // Create a polygon geometry
                let point = {
                    type: "point", // autocasts as new Polygon()
                    longitude: this.props.x,
                    latitude: this.props.y,
                    spatialReference: new SpatialReference(this.props.wkid ? this.props.wkid : 3301)
                };

                let markerSymbol = {
                    type: "simple-marker", // autocasts as new SimpleMarkerSymbol()
                    // color: this.props.color ? this.props.color : null,
                    outline: { // autocasts as new SimpleLineSymbol()
                        color: this.props.outlineColor ? this.props.outlineColor : "red",
                        width: 3
                    }
                };

                // Add the geometry and symbol to a new graphic
                const graphic = new Graphic({
                    geometry: point,
                    symbol: markerSymbol,
                    attributes: this.props.attributes ? this.props.attributes : null,
                    popupTemplate: this.props.content ? this.props.content : null,
                });

                this.setState({graphic});

                if (this.props.layerId) {
                    this.props.map.findLayerById(this.props.layerId).graphics.add(graphic);
                } else {
                    this.props.view.graphics.add(graphic);
                }

                //Radius circle
                const maintenanceRadiusM = this.props.radiusM ? this.props.radiusM : 200;
                if (this.props.radius) {
                    let circle = new Circle({
                        attributes: {maintenanceRadius: maintenanceRadiusM},
                        // longitude: this.props.x,
                        // latitude: this.props.y,
                        center: point,
                        geodesic: (this.props.wkid && (this.props.wkid === 3857 || this.props.wkid === 4326)),
                        spatialReference: new SpatialReference(this.props.wkid ? this.props.wkid : 3301),
                        radius: maintenanceRadiusM,
                        radiusUnit: "meters"
                    });
                    let circleSymbol = new SimpleFillSymbol(
                        SimpleFillSymbol.STYLE_NULL,
                        new SimpleLineSymbol(
                            SimpleLineSymbol.STYLE_SHORTDASHDOTDOT,
                            new Color([34, 180, 228]),
                            1
                        ), new Color([34, 180, 228, 0.25])
                    );
                    let graphicCircle = new Graphic({geometry: circle, symbol: circleSymbol});

                    if (this.props.layerId) {
                        this.props.map.findLayerById(this.props.layerId).graphics.add(graphicCircle);
                    } else {
                        this.props.view.graphics.add(graphicCircle);
                    }
                }

            }).catch((err) => console.error(err));
    }

    componentWillUnmount() {
        if (this.props.layerId) {
            const map = this.props.map,
                layer = (map) ? map.findLayerById(this.props.layerId) : null;
            if (layer && layer.graphics) {
                layer.graphics.remove(this.state.graphic);
            }
        } else {
            this.props.view.graphics.remove(this.state.graphic);
        }
    }
}
